import Moment from 'moment'
import datetime from './../config/datetime'

/**
 * Prepare date to readable format
 */
export default date => new Moment(date).format(datetime.FORMAT_MONTH_DAY_YEAR)
